// OWNER: Agent C. Every route in PLAN.md §6 wired to a real screen.
// /login itself is Agent A's (src/client/routes/login/**) — this file only
// wires it into the router and wraps the authenticated shell in their
// <ProtectedRoute>.
import { Routes, Route, Navigate } from "react-router";
import { ProtectedRoute } from "./lib/auth";
import { Layout, RequireDev } from "./components/Layout";
import LoginPage from "./routes/login";
import DashboardPage from "./routes/dashboard/DashboardPage";
import InvestmentsPage from "./routes/investments/InvestmentsPage";
import HoldingDetailPage from "./routes/investments/HoldingDetailPage";
import TransactionsPage from "./routes/transactions/TransactionsPage";
import NewTransactionPage from "./routes/transactions/NewTransactionPage";
import LoansPage from "./routes/loans/LoansPage";
import LoanDetailPage from "./routes/loans/LoanDetailPage";
import AdminPage from "./routes/admin/AdminPage";
import SettingsPage from "./routes/settings/SettingsPage";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/investments" element={<InvestmentsPage />} />
        <Route path="/investments/:holdingId" element={<HoldingDetailPage />} />
        <Route
          path="/transactions"
          element={
            <ProtectedRoute adminOnly>
              <TransactionsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/transactions/new"
          element={
            <ProtectedRoute adminOnly>
              <NewTransactionPage />
            </ProtectedRoute>
          }
        />
        <Route path="/loans" element={<LoansPage />} />
        <Route path="/loans/:loanId" element={<LoanDetailPage />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute adminOnly>
              <AdminPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <RequireDev>
              <SettingsPage />
            </RequireDev>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
